export const SOURCE_SCRIPT_ANSWER_HEADINGS = {
    archer: "From Archer's analysis",
    reading: 'My reading of the code',
    gaps: 'Gaps',
};
export const SOURCE_SCRIPT_ANSWER_NO_ARCHER_FACTS = "Archer's analysis has nothing recorded on this.";
const normalizeHeading = (value) => value
    .replace(/[*_`#:]/g, ' ')
    .replace(/[‘’]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
const HEADING_LOOKUP = new Map(Object.entries(SOURCE_SCRIPT_ANSWER_HEADINGS)
    .map(([source, heading]) => [normalizeHeading(heading), source]));
const HEADING_LINE = /^\s{0,3}(?:#{1,6}\s+(.+?)\s*#*\s*|\*\*(.+?)\*\*\s*:?\s*)$/;
function headingSource(line) {
    const match = HEADING_LINE.exec(line);
    if (!match)
        return null;
    return HEADING_LOOKUP.get(normalizeHeading(match[1] ?? match[2] ?? '')) ?? null;
}
export function parseSourceScriptAnswer(text) {
    const sections = [];
    let current = { source: 'reading', content: '' };
    let labelled = false;
    let inFence = false;
    const flush = () => {
        const content = current.content.trim();
        if (content)
            sections.push({ source: current.source, content });
    };
    for (const line of text.split(/\r?\n/)) {
        if (/^\s{0,3}(```|~~~)/.test(line))
            inFence = !inFence;
        const source = inFence ? null : headingSource(line);
        if (source) {
            flush();
            labelled = true;
            current = { source, content: '' };
            continue;
        }
        current.content += `${line}\n`;
    }
    flush();
    return { sections, labelled };
}
//# sourceMappingURL=sourceScriptAnswer.js.map